module.exports = __webpack_public_path__ + "static/media/campground.2913d684.svg";